import React from 'react';
import styled from 'styled-components';

import { useSelectorActiveChain } from '#/components/hooks';
import HeaderMobile from '#/components/layout/header/HeaderMobile';
import MetaTags from '#/components/layout/header/MetaTags';
import { useIsMobile } from '#/hooks/useIsMobile';
import { redirectTo } from '#/lib/redirect';
import { getDashboardUrl } from '#/reduxState/markets/listed/listedMarketsUtils';
import { scrollbarStyle } from '#/styleShared';

import MarketsStatsBoxes from './MarketsStatsBoxes';
import MarketsTable from './MarketsTable';

const Wrap = styled.div`
  height: 100%;
  overflow-y: auto;
  ${scrollbarStyle}
`;

const HeaderWrap = styled.div`
  max-width: 1200px;
  margin: 16px auto;
`;

const ContentWrap = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 8px;

  border-radius: 2px;
  background: var(--elevation-light);

  .isMobileStyle & {
    padding: 8px 0;
  }
`;

function MarketsPage() {
  const isMobile = useIsMobile();
  // const history = useHistory();
  // const { backTo } = useParams<{
  //   backTo?: string;
  // }>();
  const { activeChain } = useSelectorActiveChain();
  // const [favouriteOnly, setFavouriteOnly] = useState(false);
  return (
    <Wrap>
      <MetaTags title="Markets" />

      {isMobile ? (
        <HeaderMobile onBackClick={() => redirectTo('/mobile-more')}>
          Markets
        </HeaderMobile>
      ) : (
        <HeaderWrap>
          <h1>Markets</h1>
          {/* <br />
          <WalletAndMarketsPageCTAs /> */}
          <MarketsStatsBoxes />
        </HeaderWrap>
      )}

      <ContentWrap>
        <MarketsTable
          marketRouterLink={market => getDashboardUrl(activeChain, market)}
        />
      </ContentWrap>
    </Wrap>
  );
}

export default MarketsPage;
